import { useShadowRoot } from "@/helpers/ShadowRootContext.ts";
import { RefObject, useEffect } from "react";

export const useArrowKeyScroll = (containerRef: RefObject<HTMLDivElement | null>) => {
  const { containerEl } = useShadowRoot();

  useEffect(() => {
    const handleKey = (e: KeyboardEvent) => {
      if (!containerRef.current) return;
      if (containerEl.querySelector(".c-gallery-lightbox")) return;
      if (e.key === "ArrowUp") {
        e.preventDefault();
        containerRef.current.scrollBy({ top: -100, behavior: "smooth" });
      }
      if (e.key === "ArrowDown") {
        e.preventDefault();
        containerRef.current.scrollBy({ top: 100, behavior: "smooth" });
      }
    };
    document.addEventListener("keydown", handleKey);
    return () => document.removeEventListener("keydown", handleKey);
  }, [containerRef, containerEl]);
};
